import { Routes, Route, Navigate } from "react-router-dom";
import { Suspense, lazy } from "react";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { AnimatePresence } from "framer-motion";
import Loader from "./components/Loader";

import Layout from "./components/Layout";
import Home from "./components/Home";
const WhyVergado = lazy(() => import("./components/pages/WhyVergado"));
const ContactUs = lazy(() => import("./components/pages/ContactUs"));
const Payroll = lazy(() =>
  import("./components/pages/products/payroll/Payroll"),
);
const EmployeeBenefits = lazy(() =>
  import("./components/pages/products/EmployeeBenefits"),
);
const ExpenseManagement = lazy(() =>
  import("./components/pages/products/ExpenseManagement"),
);
const PrivacyPolicy = lazy(() => import("./components/pages/PrivacyPolicy"));
const OnBoarding = lazy(() =>
  import("./components/pages/products/onBoarding/OnBoarding"),
);
const Resources = lazy(() => import("./components/pages/resources/Resources"));
const Cash = lazy(() => import("./components/pages/products/cash/Cash"));
const AdvanceCash = lazy(() =>
  import("./components/pages/products/cash/AdvanceCash"),
);
const PettyCash = lazy(() =>
  import("./components/pages/products/cash/PettyCash"),
);
const NotFound = lazy(() => import("./components/NotFound"));
const AtsForm = lazy(() => import("./components/AtsForm"));
const ExitForm = lazy(() => import("./components/ExitForm"));
const LoiSign = lazy(() => import("./components/LoiSign"));
const FromSuccess = lazy(() => import("./components/FromSuccess"));
const Careers = lazy(() => import("./components/Careers"));
const OpenPdf = lazy(() => import("./components/publicDocuments/OpenPdf"));
const RefundPolicy = lazy(() =>
  import("./components/publicDocuments/RefundPolicy"),
);
const VergadoCardManual = lazy(() =>
  import("./components/publicDocuments/VergadoCardManual"),
);
const AppUserManual = lazy(() =>
  import("./components/publicDocuments/AppUserManual"),
);
const EmiratesID = lazy(() => import("./components/EmiratesID"));
const Pricing = lazy(() => import("./components/pages/Pricing"));
const Faq = lazy(() => import("./components/pages/Faq"));
const CompareHub = lazy(() => import("./components/pages/compare/CompareHub"));
const VsZohoPayroll = lazy(() =>
  import("./components/pages/compare/VsZohoPayroll"),
);
const VsRazorpayXPayroll = lazy(() =>
  import("./components/pages/compare/VsRazorpayXPayroll"),
);
const VsGreytHR = lazy(() => import("./components/pages/compare/VsGreytHR"));
const VsKeka = lazy(() => import("./components/pages/compare/VsKeka"));
const BlogHub = lazy(() => import("./components/pages/blog/BlogHub"));
const BlogPost = lazy(() => import("./components/pages/blog/BlogPost"));
const Glossary = lazy(() => import("./components/pages/Glossary"));
const MinimumWages = lazy(() => import("./components/pages/MinimumWages"));
const ProductsHub = lazy(() =>
  import("./components/pages/products/ProductsHub"),
);
const Recruitment = lazy(() =>
  import("./components/pages/products/Recruitment"),
);
const InductionTraining = lazy(() =>
  import("./components/pages/products/InductionTraining"),
);
const Attendance = lazy(() =>
  import("./components/pages/products/Attendance"),
);
const LeaveManagement = lazy(() =>
  import("./components/pages/products/LeaveManagement"),
);
const ComplianceFilings = lazy(() =>
  import("./components/pages/products/ComplianceFilings"),
);
const VendorManagement = lazy(() =>
  import("./components/pages/products/VendorManagement"),
);
const AssetManagement = lazy(() =>
  import("./components/pages/products/AssetManagement"),
);
const DocumentBuilder = lazy(() =>
  import("./components/pages/products/DocumentBuilder"),
);

function App() {
  const loaderState = useSelector((state) => state.global.loader);

  return (
    <>
      <AnimatePresence mode="wait">
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="applicationform/:token" element={<AtsForm />} />
            <Route path="exitform/:token" element={<ExitForm />} />
            <Route path="loi/:token" element={<LoiSign />} />
            <Route path="formsuccess" element={<FromSuccess />} />
            <Route path="term-and-condition" element={<OpenPdf />} />
            <Route
              path="termandcondition"
              element={<Navigate to="/term-and-condition" replace />}
            />
            <Route path="refund-policy" element={<RefundPolicy />} />
            <Route
              path="refundpolicy"
              element={<Navigate to="/refund-policy" replace />}
            />
            <Route path="vergadocardmanual" element={<VergadoCardManual />} />
            <Route path="appusermanual" element={<AppUserManual />} />
            <Route path="extract" element={<EmiratesID />} />
            <Route path="careers/:id" element={<Careers />} />
            <Route element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="home" element={<Navigate to="/" replace />} />
              <Route path="why-vergado" element={<WhyVergado />} />
              <Route path="contact-us" element={<ContactUs />} />
              <Route path="products" element={<ProductsHub />} />
              <Route path="products/payroll" element={<Payroll />} />
              <Route path="products/recruitment" element={<Recruitment />} />
              <Route
                path="products/induction-training"
                element={<InductionTraining />}
              />
              <Route path="products/attendance" element={<Attendance />} />
              <Route
                path="products/leave-management"
                element={<LeaveManagement />}
              />
              <Route path="products/compliance" element={<ComplianceFilings />} />
              <Route
                path="products/vendor-management"
                element={<VendorManagement />}
              />
              <Route
                path="products/asset-management"
                element={<AssetManagement />}
              />
              <Route
                path="products/document-builder"
                element={<DocumentBuilder />}
              />
              <Route path="privacy-policy" element={<PrivacyPolicy />} />
              <Route
                path="products/employee-benefits"
                element={<EmployeeBenefits />}
              />
              <Route
                path="products/expense-management"
                element={<ExpenseManagement />}
              />
              <Route path="products/onboarding" element={<OnBoarding />} />
              <Route path="products/cash" element={<Cash />} />
              <Route path="products/cash/advance" element={<AdvanceCash />} />
              <Route path="products/cash/petty" element={<PettyCash />} />
              <Route
                path="product/cash"
                element={<Navigate to="/products/cash" replace />}
              />
              <Route
                path="product/cash/advance"
                element={<Navigate to="/products/cash/advance" replace />}
              />
              <Route
                path="product/cash/petty"
                element={<Navigate to="/products/cash/petty" replace />}
              />
              <Route path="resource" element={<Resources />} />
              <Route path="pricing" element={<Pricing />} />
              <Route path="faq" element={<Faq />} />
              <Route path="compare" element={<CompareHub />} />
              <Route
                path="compare/vs-zoho-payroll"
                element={<VsZohoPayroll />}
              />
              <Route
                path="compare/vs-razorpayx-payroll"
                element={<VsRazorpayXPayroll />}
              />
              <Route path="compare/vs-greythr" element={<VsGreytHR />} />
              <Route path="compare/vs-keka" element={<VsKeka />} />
              <Route path="blog" element={<BlogHub />} />
              <Route path="blog/:slug" element={<BlogPost />} />
              <Route path="glossary" element={<Glossary />} />
              <Route path="minimum-wages" element={<MinimumWages />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </Suspense>
      </AnimatePresence>
      <ToastContainer />
      {loaderState && <Loader />}
    </>
  );
}
export default App;
